import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userType');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  studentRegister: (data) => api.post('/auth/student/register', data),
  studentLogin: (data) => api.post('/auth/student/login', data),
  adminLogin: (data) => api.post('/auth/admin/login', data),
  getCurrentUser: () => api.get('/auth/me'),
  updatePassword: (data) => api.put('/auth/update-password', data),
};

// Student APIs
export const studentAPI = {
  getProfile: () => api.get('/student/profile'),
  updateProfile: (data) => api.put('/student/profile', data),
  getDashboard: () => api.get('/student/dashboard'),
  uploadDocuments: (formData) =>
    api.post('/student/upload-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

// Payment APIs
export const paymentAPI = {
  getQRCode: () => api.get('/payment/qr-code'),
  submitPayment: (data) => api.post('/payment/submit', data),
  getPaymentStatus: () => api.get('/payment/status'),
};

// Internship APIs
export const internshipAPI = {
  getAll: (params) => api.get('/internship', { params }),
  getById: (id) => api.get(`/internship/${id}`),
  create: (data) => api.post('/internship/create', data),
  update: (id, data) => api.put(`/internship/${id}`, data),
  delete: (id) => api.delete(`/internship/${id}`),
  apply: (id) => api.post(`/internship/${id}/apply`),
  getMyApplications: () => api.get('/internship/my/applications'),
};

// Admin APIs
export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getAnalytics: (params) => api.get('/admin/analytics', { params }),
  getAllStudents: (params) => api.get('/admin/students', { params }),
  getStudentDetails: (id) => api.get(`/admin/students/${id}`),
  verifyPayment: (studentId) => api.put(`/admin/payment/verify/${studentId}`),
  rejectPayment: (studentId, data) => api.put(`/admin/payment/reject/${studentId}`, data),
  updateApplicationStatus: (id, data) => api.put(`/admin/students/${id}/application-status`, data),
  rotateQRCode: () => api.post('/admin/qr-code/rotate'),
  exportStudents: () => api.get('/admin/export/students'),
};

export default api;
